// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"310":"aa619612","441":"81e6efde","897":"5833a0ee","977":"fc699c47"}[chunkId] + ".css";
};